import React from 'react';
import TemplateParametro from '../shared/templateParametros/templateParametros';
import ParcelamentoComissaoService from '../../../../lib/api/parcelamentoComissao/parcelamentoComissao';

class ParametroParcelamentoComissao extends React.Component<{}, {}> {
	constructor(props: any) {
		super(props);
		this.state = {};
	}

	baixarExcelParametrosParcelamentoComissao() {
		return ParcelamentoComissaoService.obterExcel();
	}

	enviarParametrosEventGrid() {
		return ParcelamentoComissaoService.enviarParametrosAoEventGrid();
	}

	render() {
		return (
			<TemplateParametro
				enviarParametrosEventGrid={this.enviarParametrosEventGrid}
				baixarExcelParametros={this.baixarExcelParametrosParcelamentoComissao}
				enviarExcelParametros={ParcelamentoComissaoService.parcelamentoComissaoExcelPost}
				deletarExcelParametros={ParcelamentoComissaoService.deletarExcelParametros}
				nomeDoArquivo='Parametro Parcelamento Comissao'
			/>
		);
	}
}

export default ParametroParcelamentoComissao;
